import { z } from 'zod';

import { DevicePlatformSchema, DeviceTokenValueSchema } from '../device-token/device-token';

/**
 * Registering this device for push.
 *
 * **Idempotent by design, and it re-homes a token rather than refusing it.** FCM
 * reassigns a registration token when an app is reinstalled or a device changes
 * hands, so the same string can legitimately arrive for a second member — and
 * refusing it would leave the previous owner's notices going to somebody else's
 * phone, which is the worst of the available outcomes. The write claims the
 * token for the caller.
 */
export const DeviceTokenRegisterSchema = z
  .object({
    token: DeviceTokenValueSchema,
    platform: DevicePlatformSchema,
  })
  .strict();

export type DeviceTokenRegisterRequest = z.infer<typeof DeviceTokenRegisterSchema>;

/**
 * Deregistering on sign-out.
 *
 * The token travels in the **body** rather than the path: a token is a bearer
 * credential for the member's lock screen, and a path segment is the one part of
 * a request that reliably reaches access logs, proxies and error reporters.
 */
export const DeviceTokenDeregisterSchema = z.object({ token: DeviceTokenValueSchema }).strict();

export type DeviceTokenDeregisterRequest = z.infer<typeof DeviceTokenDeregisterSchema>;
